import { Capacitor } from '@capacitor/core'
import { Device } from '@capacitor/device'

const SUPPORTED = ['es', 'en'] as const
const DEFAULT_LOCALE: Locale = 'es'

export type Locale = typeof SUPPORTED[number]

function normalize(lang: string | null | undefined): Locale | null {
  if (!lang) return null
  const short = lang.toLowerCase().split('-')[0]
  return (SUPPORTED as readonly string[]).includes(short) ? (short as Locale) : null
}

function readCookie(name: string): string | null {
  if (typeof document === 'undefined') return null
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]+)`))
  return match ? decodeURIComponent(match[1]) : null
}

export async function resolveLocale(userLocale?: string | null): Promise<Locale> {
  // 1. user.locale
  const fromUser = normalize(userLocale)
  if (fromUser) return fromUser

  // 2. cookie
  const fromCookie = normalize(readCookie('pavemi_locale'))
  if (fromCookie) return fromCookie

  // 3. Capacitor device locale (mobile native)
  if (Capacitor.isNativePlatform()) {
    try {
      const { value } = await Device.getLanguageCode()
      const fromDevice = normalize(value)
      if (fromDevice) return fromDevice
    } catch {
      // fall through
    }
  }

  // 4. navigator.language (web)
  const fromNavigator = normalize(typeof navigator !== 'undefined' ? navigator.language : null)
  if (fromNavigator) return fromNavigator

  return DEFAULT_LOCALE
}
